import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminAccountSettings = lazy(() => import("@/pages/admin/AdminAccountSettings"));

export const Route = createFileRoute("/admin/account-settings")({
  component: AdminAccountSettings,
});
